<div id=header>
    <img id="header-icon" src={{image}} loading="lazy">
    <div>
        <h1 class="title">{{title | translate}}</h1>
        <p class="description">{{description | translate}}</p>
    </div>
</div>